<ngx-spinner type="ball-atom">
  <div class="text-white">loading...</div>
</ngx-spinner>
@if (showLayout) {<app-header></app-header>
<main class="app-container">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
}@else {
<router-outlet></router-outlet>
}